import { createContext, useContext, useEffect, useState } from "react";
import { getEnabledFeatures } from "./Api";

type FeatureProviderProps = { children: React.ReactNode };

const FeatureContext = createContext<any>(undefined);

export const FeatureProvider = ({ children }: FeatureProviderProps) => {
	const [features, setFeatures] = useState<string[]>([]);
	const [isLoading, setIsloading] = useState(true);

	useEffect(() => {
		(async () => {
			const enabledFeatures = await getEnabledFeatures();
			setFeatures(enabledFeatures);
			setIsloading(false);
		})();
	}, []);

	const value = { features, isLoading };

	return (
		<FeatureContext.Provider value={value}>{children}</FeatureContext.Provider>
	);
};

type UseFeatures = {
	features: string[];
};

export const useFeatures = (): UseFeatures => {
	const context = useContext(FeatureContext);
	if (!context)
		throw new Error("useFeatures must be used within a FeatureProvider");
	return context;
};
